import { Timestamp } from 'firebase/firestore';

/**
 * 다양한 형태의 날짜 값을 안전하게 한국어 로케일로 포맷팅하는 함수
 * @param dateValue - Firestore Timestamp, Date 객체, 문자열, 숫자 등
 * @param onlyDate - true면 날짜만, false면 날짜+시간
 * @returns 포맷팅된 날짜 문자열 또는 '-'
 */
export const formatDate = (dateValue: any, onlyDate: boolean = false): string => {
  if (!dateValue) return '-';
  try {
    let date: Date;
    // Firestore Timestamp인 경우
    if (dateValue instanceof Timestamp || (dateValue && typeof dateValue.toDate === 'function')) {
      date = dateValue.toDate();
    }
    // Date 객체인 경우
    else if (dateValue instanceof Date) {
      date = dateValue;
    }
    // 문자열인 경우
    else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    }
    // 숫자(타임스탬프)인 경우
    else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    }
    else {
      return '-';
    }
    return onlyDate ? date.toLocaleDateString('ko-KR') : date.toLocaleString('ko-KR');
  } catch (error) {
    return '-';
  }
}; 